import React, { useState } from "react";
import Box from "@mui/material/Box";
// import { useTheme } from "@mui/material/styles";
// import MobileStepper from "@mui/material/MobileStepper";
// import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
// import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
// import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import Top from "../../Top";
import Left from "../../Left";
import AddIcon from "@mui/icons-material/Add";
import {
  Button,
  Grid,
  Tabs,
  Tab,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AccessAlarmsIcon from "@mui/icons-material/AccessAlarms";
import RoomIcon from "@mui/icons-material/Room";
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import PropTypes from "prop-types";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import avtarPic from "../../../assets/Images/avtarPic.png";
import Zoom from "react-medium-image-zoom";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from '@mui/material/Pagination';

function ViewEvents() {
  const navigate = useNavigate();
  const [calendardata, setcalendardata] = useState([]);
  const [dateforlog, setdateforlog] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [eventsList, setEventsList] = useState([]);
  const [datewiseEvent, setDatewiseEvent] = useState([]);
  const [showlist, setShowlist] = useState(false);
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [openRemind, setOpenRemind] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [eventdetails, seteventdetails] = useState([]);
  const [fullname, setName] = React.useState("");
  const [contactno, setContact] = React.useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [remindcheckval, setremindcheckval] = useState(false);
  const [eventdtreminder, seteventdtreminder] = useState("");
  const [binddt, setbinddt] = React.useState("");
  const [bindtime, setbindtime] = React.useState("");
  const [, setremainderId] = useState("");
  const [remainderTime, setremainderTime] = useState("");
  const [previousremainder, setpreviousremainder] = useState(false);
  const [eventidforrsvp, seteventidforrsvp] = React.useState();
  const [eventtitle, setEventtitle] = useState("");
  const [remindermsg, setremindermsg] = React.useState(false);
  const [sendforuser, setsendforuser] = useState([]);

  const [childCount, setChildCount] = useState(1);
  const [adultCount, setAdultCount] = useState(1);
  const [goingFlag, setGoingFlag] = useState("Yes, I am Going");

  // For Modal
  const [open3, setOpen3] = useState(false);
  const [scroll3, setScroll3] = useState("paper");
  const [open4, setOpen4] = useState(false);
  const [scroll4, setScroll4] = useState("paper");
  const [groupid, setgroupid] = useState();

  const [memberId, setMemberId] = useState();
  const [showerr, setshowerr] = useState(false);
  const [activeIndexres, setActiveIndexres] = useState(null);

  const [goingresult, setgoingresult] = useState("");
  const [adultresult, setadultresult] = useState("");
  const [childresult, setchildresult] = useState("");
  const [delbtn, setdelbtn] = useState(false);
  const [addbtn, setaddbtn] = useState(false);
  const [idfordelrsvp, setidfordelrsvp] = useState();

  const [adultgocnt, setadultgocnt] = useState('');
  const [childgocnt, setchildgocnt] = useState('');
  const [adultmaygocnt, setadultmaygocnt] = useState('');
  const [childmaygocnt, setchildmaygocnt] = useState('');
  const [adultnotgocnt, setadultnotgocnt] = useState('');
  const [childnotgocnt, setchildnotgocnt] = useState('');
  const [fcmToken, setFcmToken] = useState('');
  const [q, setQ] = React.useState("");
  const [calq, setcalQ] = React.useState("");


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);


  const [currentPagecalender, setCurrentPagecalender] = useState(1);
  const [itemsPerPagecalender] = useState(5);
  const [totalItemscalender, setTotalItemscalender] = useState(0);
  // End

  // For Modal


  // End

  // const totalPages = Math.ceil(totalItems / itemsPerPage);

  // const handlePageChange = (newPage) => {
  //   if (newPage >= 1 && newPage <= totalPages) {
  //     setCurrentPage(newPage);
  //   }
  // };

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const handlePageChangecalender = (e, page) => {
    setCurrentPagecalender(page);
  };
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChangeTabs = () => {
    setcalQ("");
    setQ("");
    setShowlist(false)
  };

  const handleClickOpen2 = (scrollType, e) => {
    setShowlist(true);
    let dttime = e.split("T");
    let finaldt = dttime[0];
    setdateforlog(finaldt);
    getbydate(finaldt);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseRemind = () => {
    setbinddt("");
    setbindtime("");
    setOpenRemind(false);
    setremindermsg(false);
  };

  async function getbydate(dt) {
    setShowLoader(true);

    let bodyFormData = {
      startDate: dt,
      searchq: calq,
      pageNo: currentPagecalender,
      count: itemsPerPagecalender,
    };
    await makePostRequest("events/admin/geteventsbydate", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          if (response.data.data.data.length > 0) {
            setDatewiseEvent(response.data.data.data);
            setTotalItemscalender(response.data.data.total_records);
          } else {
            setDatewiseEvent([]);
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        let errMsg = err.response.data.message;
        swal(" " + errMsg, "", "warning", { timer: 2000, buttons: false });
        setShowLoader(false);
      });
  }

  function clickcheckbox(status) {
    const eventdate = eventdtreminder;
    console.log("ccc", status);

    if (status) {
      setremindermsg(false);

      const valDate = new Date(eventdate);
      //hour minus
      valDate.setHours(valDate.getHours() - 1);
      const resultDate = valDate.toISOString();
      const dtime = resultDate.split("T");
      const timeWithMilliseconds = dtime[1];
      const timePart = timeWithMilliseconds.slice(0, -5);
      // console.log("date", dtime[0]);
      // console.log("time", timePart);
      setbinddt(dtime[0]);
      setbindtime(timePart);
      setremindcheckval(true);
    } else {
      setbinddt("");
      setbindtime("");
      setremindermsg(true);
      setremindcheckval(false);
    }
  }

  //for calendar event data bind
  function renderEventContent(eventInfo) {
    return (
      <>
        <Button
          className="eventOutBt"
          onClick={(e) => handleClickOpen2("body", eventInfo.event.startStr)}
        >
          <div className="eventTextMainBox">
            <div>
              <b>{moment(eventInfo.event.startStr).utc().format("hh:mm A")}</b>
            </div>
            <div>
              <p>{eventInfo.event.title}</p>
            </div>
          </div>
        </Button>
      </>
    );
  }

  async function getAllEvents() {
    setShowLoader(true);
    console.log('ttt', currentPage)
    // return
    let bodyFormData = {
      searchq: q,
      sort: "newtoold",
      pageNo: currentPage,
      count: itemsPerPage,
      status: "",
    };
    await makePostRequest("events/eventsListing", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          if (response.data.data.data.length > 0) {
            // setEventsList(response.data.data.rows);
            let responsearray = [];
            for (let i = 0; i < response.data.data.data.length; i++) {
              let obj = {
                title: response.data.data.data[i].event_title,
                date: response.data.data.data[i].start_date_time,
                // minutes: response.data.data.rows[i].minutes,
              };
              responsearray.push(obj);
            }
            setcalendardata(responsearray);
            setEventsList(response.data.data.data);
            setTotalItems(response.data.data.total_records);

          } else {
            setEventsList([]);
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        let errMsg = err.response.data.message;
        swal(" " + errMsg, "", "warning", { timer: 2000, buttons: false });
        setShowLoader(false);
      });
  }

  const dateConvert = (dt) => {
    let dtval = dt;
    dtval = dtval.split("T");
    let newdt = dtval[0].split("-");
    return newdt[2];
  };

  const monthConvert = (dtv) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let dtval = dtv;
    dtval = dtval.split("T");
    let newdt = dtval[0].split("-");
    let monthval = newdt[1];
    let yr = newdt[0];
    return months[monthval - 1] + " " + yr;
  };

  const timeConvert = (dt, edt) => {

    let startTimeval = moment
      (dt).utc()
      .format("DD-MM-YYYY hh:mm A");
    let endTimeval = moment
      (edt).utc()
      .format("DD-MM-YYYY hh:mm A");
    let sTime = startTimeval.split(" ");
    let eTime = endTimeval.split(" ");
    let sval = sTime[1] + ' ' + sTime[2] + '-' + eTime[1] + ' ' + eTime[2]
    // console.log('111', sval)
    return sval;
  };

  const handleClickOpen = (scrollType, data) => () => {
    console.log("data ev", data);
    let fullname = data.name;
    fullname = fullname.split(" ");
    setName(fullname[0] + " " + fullname[1]);
    setContact(fullname[2]);

    let startTimeval = moment
      (data.start_date_time).utc()
      .format("DD-MM-YYYY hh:mm A");
    let endTimeval = moment
      (data.end_date_time).utc()
      .format("DD-MM-YYYY hh:mm A");

    let sTime = startTimeval.split(" ");
    let eTime = endTimeval.split(" ");

    setStartTime(sTime[1] + ' ' + sTime[2]);
    setEndTime(eTime[1] + ' ' + eTime[2]);
    setOpen(true);
    setScroll(scrollType);
    seteventdetails(data);
  };

  const handleClickOpenRemind = (scrollType, key) => () => {
    setOpenRemind(true);
    setremindcheckval(false);
    setScroll(scrollType);
    seteventidforrsvp(key.event_id);
    setEventtitle(key.title);
    getReminderInfo(key.event_id, localStorage.getItem("userId"));
    seteventdtreminder(key.start_date_time);
  };

  const getEventDetails = (data) => {
    localStorage.setItem("editEventData", JSON.stringify(data));
    navigate("/EditEvent/" + data.event_id);
    // setOpen2(true);
    // setScroll(scrollType);
  };

  const getReminderInfo = async (eid, uid) => {
    setShowLoader(true);
    await makeGetRequest(`remainder/ViewRemainderinfo/${eid}/${uid}`)
      .then((response) => {
        if (response.status == "201") {
          if (response.data.data.length > 0) {
            setpreviousremainder(true);
            setremindcheckval(true);
            setremainderId(response.data.data[0].remainderid);
            setremainderTime(response.data.data[0].rdate_time);
          } else {
            setremindcheckval(false);

            setpreviousremainder(false);
            setremainderTime("");
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("111 There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("222 There was an error!", "more error details", "warning");
      });
  };

  const addReminder = async () => {
    let finalentrydt = [binddt, bindtime].join(" ");
    //   if (previousremainder) {
    //     console.log('hi');
    //     var idstr = remainderId;

    //     await makeGetRequest("remainder/deletereminder/" + idstr)
    //     .then((response) => {
    //       if (response.status == "201") {
    //         openRemind(false);
    //     } else {
    //       setShowLoader(false);
    //       swal("There was an error!", response.message, "warning");
    //     }
    //   })
    //   .catch((err) => {
    //     setShowLoader(false);
    //     swal("There was an error!", "more error details", "warning");
    //   });
    // }

    if (binddt == "" || bindtime == "") {
      setremindermsg(true);
      return false;
    } else {
      setremindermsg(false);
      let inputdata;
      inputdata = {
        revent_id: eventidforrsvp,
        rmember_id: localStorage.getItem("userId"),
        rdate_time: finalentrydt,
        revent_title: eventtitle,
      };

      await makePostRequest("remainder/addremainder", inputdata)
        .then((response) => {
          if (response.status == "201") {
            swal("Success", "Remainder added successfully", "success", {
              timer: 1000,
              buttons: false,
            });

            setOpenRemind(false);
            setbinddt("");
            setbindtime("");
            setShowLoader(false);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }
  };

  //for rsvp

  const handleClickOpen3 = (scrollType, key) => async () => {
    let memsend = key.member_id_list;
    setOpen3(true);
    setScroll3(scrollType);
    setidfordelrsvp();
    setdelbtn(false);
    setaddbtn(false);
    setActiveIndexres(null);
    setFcmToken("");
    seteventidforrsvp(key.event_id);
    setgroupid(key.group_id);
    getmembersList(memsend, key.event_id)
    // if (memsend.length > 0) {
    //   setShowLoader(true);
    //   let inputdata = {
    //     id: memsend,
    //     eventId: key.event_id
    //   };

    //   await makePostRequest("commonapis/getmembersData", inputdata)
    //     .then((response) => {
    //       if (response.status === 201) {
    //         setsendforuser(response.data.data.rows);
    //         setShowLoader(false);
    //         console.log(response.data.data.rows);
    //       } else {
    //         setShowLoader(false);
    //         swal("There was an error!", response.message, "warning");
    //       }
    //     })
    //     .catch((err) => {
    //       setShowLoader(false);
    //       swal("There was an error!", "more error details", "warning");
    //     });
    // } else {
    //   setsendforuser([]);
    // }
  };


  const getmembersList = async (memsend, eid) => {
    if (memsend.length > 0) {
      setShowLoader(true);
      let inputdata = {
        id: memsend,
        eventId: eid
      };

      await makePostRequest("commonapis/getmembersData", inputdata)
        .then((response) => {
          if (response.status === 201) {
            setsendforuser(response.data.data.rows);
            setShowLoader(false);
            console.log(response.data.data.rows);
          } else {
            setShowLoader(false);
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      setsendforuser([]);
    }
  }
  async function selectedResident(residentObj) {
    setshowerr(false);
    setActiveIndexres(residentObj.resident_id);
    setMemberId(residentObj.resident_id);
    setFcmToken(residentObj.fcm_token)
    viewRsvpinfo(eventidforrsvp, residentObj.resident_id);
  }

  const viewRsvpinfo = async (eventId, rId) => {
    setShowLoader(true);
    await makeGetRequest(`rsvp/getRsvpInfo/${eventId}/${rId}`)
      .then((response) => {
        if (response.status == "201") {
          if (response.data.data.length > 0) {
            setdelbtn(true);
            setaddbtn(false);
            setgoingresult(response.data.data[0].going_flag);
            setadultresult(response.data.data[0].adults);
            setchildresult(response.data.data[0].children);
            setidfordelrsvp(response.data.data[0].rsvpid);

            setShowLoader(false);
          } else {
            setShowLoader(false);
            setdelbtn(false);
            setaddbtn(true);
          }
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  };

  const handleDeleteRSVP = async () => {

    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete this record? This process cannot be undone.",
      icon: "warning",
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      setShowLoader(true);
      var bodyFormData = new FormData();
      makeGetRequest("rsvp/deleteRsvp/" + idfordelrsvp, bodyFormData)
        .then((response) => {
          if (response.status == "200") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            setOpen3(false);
            setidfordelrsvp();
            setdelbtn(false);
            setaddbtn(false);
            setActiveIndexres(null);
            setShowLoader(false);
          } else {
            setShowLoader(false);
            swal("Error", "Failed to delete", "error");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }
  };

  const handleClose3 = () => {
    setOpen3(false);
    setActiveIndexres(null);
    setdelbtn(false);
    setaddbtn(false);
  };

  const handleSelectrsvp = (e) => {
    setGoingFlag(e.target.value);
  };

  const handleAdultCount = (e) => {
    setAdultCount(e.target.value);
  };

  const handleChildCount = (e) => {
    setChildCount(e.target.value);
  };

  const addRsvp = async () => {
    console.log(fcmToken)
    // return
    if (memberId > 0) {
      setshowerr(false);
      setShowLoader(true);
      let inputdata;
      inputdata = {
        event_id: eventidforrsvp,
        member_id: memberId,
        group_id: groupid,
        going_flag: goingFlag,
        children: childCount,
        adults: adultCount,
      };

      await makePostRequest("rsvp/addrsvp", inputdata)
        .then((response) => {
          if (response.status == "201") {
            swal("Success", "RSVP added successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            setdelbtn(false);
            setaddbtn(false);
            setOpen3(false);
            setActiveIndexres(null);
            setShowLoader(false);

            // send notification for user

            // var jsonObj = { id: id, fname: fname, lname: lname,picture:profile_pic,guest_type:guest_type };
            if (fcmToken == null || fcmToken == "") {
              swal('Can not send notification,as FCM token not avaiable')
              setOpen3(false);
            } else {
              let bodyFormData = {
                title: "RSVP added",
                message: "RSVP added",
                firebaseToken: fcmToken,
              };

              makePostRequest("guards/sendNotification", bodyFormData)
                .then((response) => {
                  swal("Success", "RSVP added", "success", {
                    timer: 1000,
                    buttons: false,
                  });

                })
                .catch((err) => {
                  swal(
                    "There was an error in sending Notification!!",
                    "more error details",
                    "warning"
                  );
                });
            }



          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      setShowLoader(false);
      setshowerr(true);
    }
  };

  const handleClickOpen4 = (scrollType, key) => () => {
    setOpen4(true);
    setScroll4(scrollType);
    viewrsvpDetils(key.event_id);
    getmembersList(key.member_id_list, key.event_id)
  };

  const handleClose4 = () => {
    // setEventtitle("")
    setOpen4(false);
  };


  const viewrsvpDetils = async (eventId) => {
    setShowLoader(true);
    await makeGetRequest(`rsvp/viewrsvpbyid/${eventId}`)
      .then((response) => {
        setEventtitle(response.data.data[0].event_title);
        setadultgocnt(response.data.data[0].adults_yesgoing);
        setchildgocnt(response.data.data[0].children_yesgoing);
        setadultmaygocnt(response.data.data[0].adults_maygoing);
        setchildmaygocnt(response.data.data[0].children_maygoing);
        setadultnotgocnt(response.data.data[0].adults_notgoing);
        setchildnotgocnt(response.data.data[0].children_notgoing);
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  };

  // React.useEffect(() => {
  //   // getAllEvents();
  //   // if (calq) {
  //   //   getbydate(dateforlog)
  //   // } else {
  //   //   getAllEvents();
  //   // }
  //   if (q || value==0 || currentPage) {
  //     getAllEvents();
  //     // setCurrentPage(1)
  //   } else {
  //     getbydate(dateforlog)
  //   }
  // }, [q, calq, currentPage,currentPagecalender]);

  //  currentPage 1
  React.useEffect(() => {
    if (q || value === 0) {
      setCurrentPage(1);
    } else if (calq || value === 1) {
      setCurrentPagecalender(1)
    }
  }, [q, calq]);

  // Main
  React.useEffect(() => {
    if ((q || value === 0) && currentPage === 1) {
      getAllEvents();
    } else if (currentPage && value === 0) {
      getAllEvents();
    } else if (calq || currentPagecalender) {
      getbydate(dateforlog);
    }
  }, [q, calq, currentPage, currentPagecalender]);



  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">

        <div className="noticeTabMain">
          {/* <tabs /> */}
          <Button
            className="contentTopLefBt primaryBtn"
            onClick={() => navigate("/AddEvent")}
          > Add New Event </Button>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="All Events"
                  {...a11yProps(0)}
                  onClick={() => handleChangeTabs()}
                />
                <Tab
                  label="Calendar"
                  {...a11yProps(1)}
                  onClick={() => handleChangeTabs()}
                />
              </Tabs>
            </Box>
            {/* for all event */}
            {(value == 0) &&
              <div className="visitorSearchDiv searchTopSP">
                <SearchIcon className="visitorSearchIco" />
                <input
                  type="text"
                  placeholder="Search by event title"
                  onChangeCapture={(e) => setQ(e.target.value)}
                />
              </div>}
            <TabPanel value={value} index={0} className="NoticeTabPanle">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="residentHeading">All Events</div>
                  <div className="addAgencyMain" style={{ paddingTop: 20 }}>
                    <div className="eventListingMain">
                      {" "}
                      {eventsList.length > 0 ? (
                        <>
                          {eventsList.map((item, index) => (
                            <div className="veentDv">
                              <div className="eventDateDiv">
                                <b>{dateConvert(item.start_date_time)}</b>{" "}
                                <span>{monthConvert(item.start_date_time)}</span>
                              </div>
                              <div
                                className="eventCenterDiv"
                                onClick={handleClickOpen("body", item)}
                              >
                                <h1>
                                  <NotificationsActiveIcon /> {item.event_title}
                                </h1>
                                <span>
                                  <AccessAlarmsIcon />{" "}
                                  {timeConvert(item.start_date_time, item.end_date_time)}
                                  (Time)
                                </span>
                                <p>
                                  <RoomIcon /> {item.event_venue} (Venue)
                                </p>
                              </div>
                              <div className="eventfindMoreDiv" onClick={() => getEventDetails(item)}>
                                <EditIcon
                                  className="pencilIcon"
                                  // onClick={() => getEventDetails(item)}
                                />
                                <em>Edit</em>
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div className="noTickTx">No Event Available....</div>
                      )}
                    </div>
                    <Grid container spacing={3} >
                      <Grid item xs={12} md={12} >
                        <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                          page={currentPage}
                          onChange={handlePageChange}
                          variant="outlined"
                          shape="rounded" />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>


              {/* <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          Previous Page
        </button>
        <span> Page {currentPage} of {totalPages} </span>
        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Next Page
        </button> */}
              {/* <Pagination count={totalPages} variant="outlined" shape="rounded" onClick={() => setCurrentPage(currentPage)}/> */}



            </TabPanel>

            {/* Calendar tab */}
            <TabPanel value={value} index={1} className="NoticeTabPanle">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="residentHeading">Calendar</div>
                  <div className="addAgencyMain" style={{ paddingTop: 20 }}>
                    <div className="forCalenderWidth">
                      <FullCalendar
                        plugins={[dayGridPlugin]}
                        initialView="dayGridMonth"
                        events={calendardata}
                        eventContent={renderEventContent}
                        dayMaxEvents={1}
                        // eventClick={handleEventClick}

                        headerToolbar={{
                          start: "", // Leave the start section empty to hide the default "today" button
                          center: "title",
                          end: "prev,next",
                        }}
                      />
                    </div>
                    {showlist && (
                      <div className="eventListingMain">
                        <div className="visitorSearchDiv">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            value={calq}
                            type="text"
                            placeholder="Search by event title"
                            onChangeCapture={(e) => setcalQ(e.target.value)}
                          />
                        </div>
                        {datewiseEvent.length > 0 ? (
                          <>
                            {datewiseEvent.map((item, index) => (
                              <div className="veentDv">
                                <div className="eventDateDiv">
                                  <b>{dateConvert(item.start_date_time)}</b>{" "}
                                  <span>{monthConvert(item.start_date_time)}</span>
                                </div>
                                <div
                                  className="eventCenterDiv"
                                  onClick={handleClickOpen("body", item)}
                                >
                                  <h1>
                                    <NotificationsActiveIcon /> {item.event_title}
                                  </h1>
                                  <span>
                                    <AccessAlarmsIcon />{" "}
                                    {timeConvert(item.start_date_time, item.end_date_time)}
                                    (Time)
                                  </span>
                                  <p>
                                    <RoomIcon /> {item.event_venue} (Venue)
                                  </p>
                                </div>
                                {(item.allow_rsvp === 1) &&
                                  <div className="rsvpOter">
                                    <div>

                                      <Button
                                        style={{
                                          background: "#ffd7a4",
                                          border: "1px solid #ebb877",
                                        }}
                                        onClick={handleClickOpen3("body", item)}
                                      >
                                        <AddIcon /> Add RSVP
                                      </Button>

                                    </div>
                                    <div>
                                      <Button
                                        className=""
                                        onClick={handleClickOpen4("body", item)}
                                      >
                                        RSVP Details
                                      </Button>
                                    </div>
                                  </div>
                                }
                                <div
                                  className="eventfindMoreDiv"
                                  onClick={handleClickOpenRemind("body", item)}
                                >
                                  Reminder
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <div className="noTickTx">No Event Available....</div>
                        )}
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
              {datewiseEvent.length > 0 &&
                <div>
                  <Pagination count={Math.ceil(totalItemscalender / itemsPerPagecalender)}
                    page={currentPagecalender}
                    onChange={handlePageChangecalender}
                    variant="outlined"
                    shape="rounded" />
                </div>
              }
            </TabPanel>
          </Box>
        </div>
      </div>

      {/* modalbox for event details */}
      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setOpen(false);
            }
          }}
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Event Details</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div className="eventDetailsPop">
                <p>
                  <label>Event Title :</label>
                  <span>{eventdetails.event_title}</span>
                </p>
                <p>
                  <label>Event Creator :</label>
                  <span>{fullname}</span>
                </p>
                <p>
                  <label>Creator Contact :</label>
                  <span>{contactno}</span>
                </p>
                <p>
                  <label>Event Date :</label>
                  <span>
                    {moment
                      (eventdetails.start_date_time)
                      .format("DD-MM-YYYY")}
                  </span>
                </p>
                <p>
                  <label>Start Time :</label>
                  <span>{startTime}</span>
                </p>
                <p>
                  <label>End Time :</label>
                  <span>{endTime}</span>
                </p>
                <p>
                  <label>Event Venue :</label>
                  <span>{eventdetails.event_venue}</span>
                </p>
                <p>
                  <label>Event Description :</label>
                  <span>{eventdetails.event_description}</span>
                </p>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* modalbox for event reminder */}
      <div className="modalMain">
        <Dialog
          open={openRemind}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setOpenRemind(false);
            }
          }}
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Remind me at </span>
            <CloseIcon className="modalCloseBt" onClick={handleCloseRemind} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div className="eventDetailsPop">
                <div className="remindMe">
                  {previousremainder && (
                    <p>
                      Current Reminder:{" "}
                      {moment.utc(remainderTime).format("DD-MM-YYYY hh:mm A")}
                    </p>
                  )}
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(event) =>
                          clickcheckbox(event.target.checked)
                        }
                        checked={remindcheckval}
                      />
                    }
                  />
                  Remind me before 1 hour
                </div>
                {remindermsg && (
                  <div style={{ color: "red" }} className="errorField">
                    Please select checkbox
                  </div>
                )}
                {!previousremainder && (
                  <Button className="primaryBtn" onClick={() => addReminder()}>
                    OK
                  </Button>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Add RSVP */}
      <div className="modalMain">
        <Dialog
          open={open3}
          // onClose={handleClose}
          scroll={scroll3}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add RSVP </span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent dividers={scroll3 === "paper"}>
            <div className="modalInnerCont">
              <div className="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <label className="tabsLabel">Select Member</label>
                    <div className="visitContDivScroll">
                      <Grid item xs={12} md={12}>
                        {sendforuser.length > 0 ? (
                          <>
                            {sendforuser.map((option) => (
                              <div
                                div
                                key={option.resident_id}
                                className={
                                  option.resident_id === activeIndexres
                                    ? "visitContDiv visitContDivNotice activeTicketList"
                                    : "visitContDiv visitContDivNotice"
                                }
                                onClick={() => selectedResident(option)}
                              >
                                <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                                  {option.apartment ? (
                                    <>
                                      {option.apartment.map((resApt, index) => (
                                        <>
                                          {resApt.is_current_stay == true &&
                                            option.user_type ==
                                            "Resident User" ? (
                                            <div className="NewTailCountOut miniBox">
                                              <div className="buildingNameNcount">
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[0]
                                                  }
                                                </p>
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[1]
                                                  }
                                                </p>
                                              </div>
                                              <h1>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[2]
                                                }
                                              </h1>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ))}
                                      {option.currentstaycnt.count == 0 &&
                                        option.user_type == "Resident User" ? (
                                        <div className="NewTailCountOut defaultTailCount miniBox">
                                          <div className="buildingNameNcount">
                                            <p>No Apart.</p>
                                            <p>Occupied</p>
                                          </div>
                                          <h1>F-000</h1>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {option.user_type == "tenent" && (
                                        <>
                                          {option.apartment.map(
                                            (resApt, index) => (
                                              <div className="NewTailCountOut miniBox">
                                                <div className="buildingNameNcount">
                                                  <p>
                                                    {
                                                      resApt.uniq_apt_name.split(
                                                        "/"
                                                      )[0]
                                                    }
                                                  </p>
                                                  <p>
                                                    {
                                                      resApt.uniq_apt_name.split(
                                                        "/"
                                                      )[1]
                                                    }
                                                  </p>
                                                </div>
                                                <h1>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[2]
                                                  }
                                                </h1>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <div className="NewTailCountOut defaultTailCount miniBox">
                                        <div className="buildingNameNcount">
                                          <p>No Apart.</p>
                                          <p>Occupied</p>
                                        </div>
                                        <h1>F-000</h1>
                                      </div>
                                    </>
                                  )}

                                  <div className="visitContProf">
                                    {option.user_obj.profile_pic ? (
                                      <Zoom>
                                        <img
                                          src={option.user_obj.profile_pic}
                                        />
                                      </Zoom>
                                    ) : (
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    )}
                                  </div>
                                  <div className="visitContLeft">
                                    <h3 className="visitContHed">
                                      {option.user_obj.first_name}{" "}
                                      {option.user_obj.last_name}{" "}
                                    </h3>
                                    <p className="visitContMob">
                                      {option.user_obj.contact_no}
                                    </p>
                                  </div>
                                  <div className="visitBottCont forMyTexAlign">
                                    {option.apartment ? (
                                      <div>
                                        <>
                                          {option.apartment.map((opt) => (
                                            <>
                                              {(opt.is_current_stay == true ||
                                                opt.occupancy_type ==
                                                "Vacant") &&
                                                option.user_type ==
                                                "Resident User" ? (
                                                <b className="visitContMob">
                                                  {opt.uniq_apt_name}
                                                  <em>{opt.occupancy_type}</em>
                                                  <br />
                                                </b>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          ))}
                                        </>

                                        {option.user_type == "tenent" && (
                                          <>
                                            {option.apartment.map(
                                              (opt1, index) => (
                                                <b className="visitContMob">
                                                  {opt1.uniq_apt_name}
                                                  <em>{opt1.occupancy_type}</em>
                                                </b>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                    ) : (
                                      <div>No Apartment Allocated</div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <span>No Members</span>
                        )}
                        {showerr ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required"}
                          </div>
                        ) : null}
                      </Grid>
                    </div>
                  </Grid>
                </Grid>

                {addbtn && (
                  <Grid container spacing={3} style={{ marginTop: 5 }}>
                    <Grid item xs={12} md={4}>
                      <label className="tabsLabel">RSVP</label>
                      <select
                        className="inputSt"
                        value={goingFlag}
                        onChange={handleSelectrsvp}
                      >
                        <option value="Yes, I am Going">Yes, I am Going</option>
                        <option value="May be Going">May be Going</option>
                        <option value="Decline">Decline</option>
                      </select>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <label className="tabsLabel">Adults</label>
                      <select
                        className="inputSt"
                        value={adultCount}
                        onChange={handleAdultCount}
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                      </select>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <label className="tabsLabel">Children</label>
                      <select
                        className="inputSt"
                        value={childCount}
                        onChange={handleChildCount}
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                      </select>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <div className="modalMainBtMain">
                        <Button
                          className="modalMainBt"
                          onClick={() => addRsvp()}
                        >
                          Add RSVP
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                )}

                {delbtn && (
                  <Grid container spacing={3} style={{ marginTop: 5 }}>
                    <Grid item xs={12} md={4}>
                      <label className="tabsLabel">RSVP: {goingresult} </label>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <label className="tabsLabel">Adults: {adultresult}</label>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <label className="tabsLabel">
                        Children: {childresult}
                      </label>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <div className="modalMainBtMain">
                        <Button
                          className="modalMainBt"
                          onClick={() => handleDeleteRSVP()}
                        >
                          Delete RSVP
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* RSVP Details */}
      <div className="modalMain">
        <Dialog
          open={open4}
          // onClose={handleClose}
          scroll={scroll4}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>RSVP Details</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose4} />
          </DialogTitle>
          <DialogContent dividers={scroll4 === "paper"}>
            <div className="modalInnerCont">
              <div className="successfullAdd rsvpTablOutr">
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <h6>{eventtitle}</h6>
                    <div className="priceTbMain">
                      <table width="100%">
                        <tr>
                          <th>Type</th>
                          <th>Yes Going</th>
                          <th>May be Going</th>
                          <th>Not Going</th>
                        </tr>
                        <tr>
                          <td>Adults</td>
                          <td>{adultgocnt}</td>
                          <td>{adultmaygocnt}</td>
                          <td>{adultnotgocnt}</td>
                        </tr>
                        <tr>
                          <td>Children</td>
                          <td>{childgocnt}</td>
                          <td>{childmaygocnt}</td>
                          <td>{childnotgocnt}</td>
                        </tr>
                      </table>
                    </div>



                    <Grid item xs={12} md={12}>
                      <label className="tabsLabel">Members</label>
                      <div className="visitContDivScroll">
                        <Grid item xs={12} md={12}>
                          {sendforuser.length > 0 ? (
                            <>
                              {sendforuser.map((option) => (
                                <div

                                  key={option.resident_id}
                                  className={
                                    "visitContDiv visitContDivNotice"
                                  }

                                >
                                  <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                                    {option.apartment ? (
                                      <>
                                        {option.apartment.map((resApt, index) => (
                                          <>
                                            {resApt.is_current_stay == true &&
                                              option.user_type ==
                                              "Resident User" ? (
                                              <div className="NewTailCountOut miniBox">
                                                <div className="buildingNameNcount">
                                                  <p>
                                                    {
                                                      resApt.uniq_apt_name.split(
                                                        "/"
                                                      )[0]
                                                    }
                                                  </p>
                                                  <p>
                                                    {
                                                      resApt.uniq_apt_name.split(
                                                        "/"
                                                      )[1]
                                                    }
                                                  </p>
                                                </div>
                                                <h1>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[2]
                                                  }
                                                </h1>
                                              </div>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        ))}
                                        {option.currentstaycnt.count == 0 &&
                                          option.user_type == "Resident User" ? (
                                          <div className="NewTailCountOut defaultTailCount miniBox">
                                            <div className="buildingNameNcount">
                                              <p>No Apart.</p>
                                              <p>Occupied</p>
                                            </div>
                                            <h1>F-000</h1>
                                          </div>
                                        ) : (
                                          <></>
                                        )}

                                        {option.user_type == "tenent" && (
                                          <>
                                            {option.apartment.map(
                                              (resApt, index) => (
                                                <div className="NewTailCountOut miniBox">
                                                  <div className="buildingNameNcount">
                                                    <p>
                                                      {
                                                        resApt.uniq_apt_name.split(
                                                          "/"
                                                        )[0]
                                                      }
                                                    </p>
                                                    <p>
                                                      {
                                                        resApt.uniq_apt_name.split(
                                                          "/"
                                                        )[1]
                                                      }
                                                    </p>
                                                  </div>
                                                  <h1>
                                                    {
                                                      resApt.uniq_apt_name.split(
                                                        "/"
                                                      )[2]
                                                    }
                                                  </h1>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="NewTailCountOut defaultTailCount miniBox">
                                          <div className="buildingNameNcount">
                                            <p>No Apart.</p>
                                            <p>Occupied</p>
                                          </div>
                                          <h1>F-000</h1>
                                        </div>
                                      </>
                                    )}

                                    <div className="visitContProf">
                                      {option.user_obj.profile_pic ? (
                                        <Zoom>
                                          <img
                                            src={option.user_obj.profile_pic}
                                          />
                                        </Zoom>
                                      ) : (
                                        <img alt="Remy Sharp" src={avtarPic} />
                                      )}
                                    </div>
                                    <div className="visitContLeft">
                                      <h3 className="visitContHed">
                                        {option.user_obj.first_name}{" "}
                                        {option.user_obj.last_name}{" "}
                                      </h3>
                                      <p className="visitContMob">
                                        {option.user_obj.contact_no}
                                      </p>
                                    </div>

                                    <div className="visitBottCont forMyTexAlign">
                                      {option.apartment ? (
                                        <div>
                                          <>
                                            {option.apartment.map((opt) => (
                                              <>
                                                {(opt.is_current_stay == true ||
                                                  opt.occupancy_type ==
                                                  "Vacant") &&
                                                  option.user_type ==
                                                  "Resident User" ? (
                                                  <b className="visitContMob">
                                                    {opt.uniq_apt_name}
                                                    <em>{opt.occupancy_type}</em>
                                                    <br />
                                                  </b>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ))}
                                          </>

                                          {option.user_type == "tenent" && (
                                            <>
                                              {option.apartment.map(
                                                (opt1, index) => (
                                                  <b className="visitContMob">
                                                    {opt1.uniq_apt_name}
                                                    <em>{opt1.occupancy_type}</em>
                                                  </b>
                                                )
                                              )}
                                            </>
                                          )}
                                        </div>
                                      ) : (
                                        <div>No Apartment Allocated</div>
                                      )}
                                    </div>

                                    <div>
                                      {(option?.rsvp_info != null) &&
                                        <>
                                          <p>
                                            Adults: {option?.rsvp_info?.adults}
                                          </p>
                                          <p>
                                            Children: {option?.rsvp_info?.children}

                                          </p>
                                          <p>
                                            RSVP: {option?.rsvp_info?.going_flag}

                                          </p>
                                        </>
                                      }
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            <span>No Members</span>
                          )}

                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={handleClose4}>Ok</Button>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader && (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      )}
    </>
  );
}

export default ViewEvents;
